import NavigationBar from "./NavigationBar";
import LandingPageBanner from "./LandingPageBanner";
import { useEffect, useRef } from "react";
import { getCurrentUserDetail } from "store/slices/UserSlice";
import { connect, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { checkIfUserIsLoggedIn } from "shared/utility/AuthUtility";
import CurrentUserResponse from "interfaces/response/CurrentUserResponse";
import AboutTimePhasing from "./AboutTimePhasing";
import TimePhasingWorkingSteps from "./TimePhasingWorkingSteps";
import TimePhasingFeatures from "./TimePhasingFeatures";
import Customers from "./Customers";
import PlansAndPricing from "./PlansAndPricing";
import LandingPageFooter from "./LandingPageFooter";
import { Docs } from "fetaures/docs";
import LandingPageHeading from "./LandingPageHeading";
import { setSelectedProductId } from "store/slices/ProductSlice";
import { getConfiguration } from "shared/utility/ConfigUtility";

interface Props {
  isUserLoggedIn?: boolean;
  currentUserDetail?: CurrentUserResponse | null;
  docsSelectedIndex: number;
}

export function LandingPage(props: Props) {
  const dispatch: AppDispatch = useDispatch();

  const { isUserLoggedIn, currentUserDetail, docsSelectedIndex } = props;
  const getStartedSectionRef = useRef(null);

  useEffect(() => {
    // Load user detail if user is logged in but user detail is not loaded already.
    if (isUserLoggedIn && !currentUserDetail) {
      dispatch(getCurrentUserDetail());
    }
  }, [dispatch, isUserLoggedIn, currentUserDetail]);

  useEffect(() => {
    const defaultProductId = getConfiguration("defaultProductId");
    dispatch(setSelectedProductId(defaultProductId));
  }, []);

  const BannerAndNavigationBarContainer = ({ children }: { children: any }) => {
    return <div className="mx-8 lg:mx-25">{children}</div>;
  };

  const ContentContainer = ({ children }: { children: any }) => {
    return <div className="mx-8 xl:mx-35">{children}</div>;
  };

  const handleLearnMoreClick = () => {
    const node = getStartedSectionRef.current as any;
    node.scrollIntoView();
  };

  return (
    <div>
      <div className="sticky top-0 z-50 bg-white">
        <BannerAndNavigationBarContainer>
          <div className="hidden lg:block">
            <NavigationBar />
          </div>
          <div className="block lg:hidden">
            <NavigationBar enableVisibilityOnScroll />
          </div>
        </BannerAndNavigationBarContainer>
      </div>

      <div className="mt-10 lg:mt-0">
        <BannerAndNavigationBarContainer>
          <LandingPageBanner onLearnMoreClick={handleLearnMoreClick} />
        </BannerAndNavigationBarContainer>
      </div>
      <div className="mt-10 xxl:mt-29 bg-mint relative pt-15 pb-50 ">
        <div className="mb-10">
          <ContentContainer>
            <AboutTimePhasing />
          </ContentContainer>
        </div>

        <div className="absolute w-full">
          <ContentContainer>
            <TimePhasingWorkingSteps />
          </ContentContainer>
        </div>
      </div>
      <div className="h-125 md:h-81 lg:h-96"></div>
      <div className="mt-10">
        <ContentContainer>
          <TimePhasingFeatures />
        </ContentContainer>
      </div>
      <div className="bg-mint py-16 mt-37">
        <ContentContainer>
          <Customers />
        </ContentContainer>
      </div>
      <div className="pt-17 pb-25">
        <ContentContainer>
          <PlansAndPricing />
        </ContentContainer>
      </div>
      <div className="bg-mint pt-17 pb-25" ref={getStartedSectionRef}>
        <ContentContainer>
          <LandingPageHeading text="Get started" classNames="mb-10" />
          <Docs dispatch={dispatch} selectedIndex={docsSelectedIndex} />
        </ContentContainer>
      </div>
      <div className="px-0 lg:px-25">
        <LandingPageFooter />
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    isUserLoggedIn: checkIfUserIsLoggedIn(),
    currentUserDetail: state.userData.currentUserDetail,
    docsSelectedIndex: state.docsData.selectedIndex,
  };
};

export default connect(mapStateToProps)(LandingPage);
